import { setPageName } from '../redux'

const reduxLink = (link, dispatch) => {
  dispatch(setPageName(link))
}

export default reduxLink
